import classNames from "utils/class-names";

export const NOTIFICATION_COLUMNS_DATA = ({ readNotification }) => [
    {
        Header: "S.No",
        accessor: "_index",
        disableSortBy: true,
    },
    {
        Header: "Notification Title",
        accessor: "title",
        disableSortBy: true,
    },
    {
        Header: "Message",
        accessor: "message",
        disableSortBy: true,
    },
    {
        Header: "",
        accessor: "ids",
        disableSortBy: true,
        Cell: ({ cell }) => {
            return (
                <>
                    <button
                        // disabled={!filters.is_active}
                        // className={classNames("btn dropdown-toggle", {
                        //     "btn-primary": filters.is_active,
                        //     "btn-secondary": !filters.is_active,
                        // })}
                        className="btn dropdown-toggle btn-primary"
                        type="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                    >
                        More...
                    </button>
                    <ul className="dropdown-menu">
                        <li>
                            <button
                                className="dropdown-item"
                                onClick={() => readNotification(cell.row.original)}
                            // onClick={() => console.log("cell.row.original", cell.row.original)}
                            >
                                Read
                            </button>
                        </li>
                        {/* <li>
                            <button
                                className="dropdown-item"
                            // onClick={() => deleteRow(cell.row.original)}
                            >
                                Delete
                            </button>
                        </li> */}
                    </ul>
                </>
            );
        },
    },
];